import { EKRANI_OPERATERA, EkranOperatera } from './pomoc/tekstovi';

/**
 * Kartica operaterskog ekrana iz adrese (`?ekran=rezervacije`).
 *
 * Link iz Viber poruke šefu magacina vodi pravo na rezervacije za kupce (Black
 * November, 19.10.2026). Nepoznato ili prazno je planiranje, kao i do sada.
 */
export function ekranIzAdrese(search: string): EkranOperatera {
  try {
    const trazeno = new URLSearchParams(search).get('ekran') ?? '';
    return (EKRANI_OPERATERA as readonly string[]).includes(trazeno)
      ? (trazeno as EkranOperatera)
      : 'planiranje';
  } catch {
    return 'planiranje';
  }
}
